$('.wpcf7c-btn-back').click(function(){
  $('form').removeClass('custom-wpcf7c-confirmed');
  $('form').addClass('init');
  // $('form').data('status', 'init');
  $('form').attr('data-status', 'init');
  // data-status
});